import React, { Component } from 'react';
import './App.css';
import AppEntry from './AppEntry.js'


//<a href={'https://play.google.com/store/apps/details?id=wagner.rainer.apps.' + appObj.link}>{appObj.appName}</a> 

class Selection extends Component {
  
  
  
  constructor(props)
  {
	super(props);
	
  }
  
  renderImage(appObj,index) {
	
    return (
      <div className={index%2 == 0 ? "App-selectionA" : "App-selectionB"}>       
		<a href={'https://play.google.com/store/apps/details?id=wagner.rainer.apps.' + appObj.link} target="_blank">
		<img src={'img/' + appObj.icon} width="128" height="128"/><br/>
		<p>{appObj.appName}</p>
		</a>
      </div>
    );
  }
   
  render() {
    return (
      <div className="gallery">
        <div className="images">
			
          {this.props.apps.map((appObj,index) => this.renderImage(appObj,index))}
			
        </div>
      </div>
    );
  }
}

Selection.propTypes = {
  apps: React.PropTypes.arrayOf(AppEntry).isRequired,
};

export default Selection;


// WEBPACK FOOTER //
// ./src/Selection.js